/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    query ContactBookDirectoryReadQuery($customerId: ID!, $contactBookDirectoryToSearch: String, $take: PositiveInt, $skip: Int) {
      ContactBookDirectoryRead(customerId: $customerId, contactBookDirectoryToSearch: $contactBookDirectoryToSearch, take: $take, skip: $skip) {
        id,
        createdAt,
        updatedAt,
        displayName,
        status,
        message,
        _totalCount
    }
  }
`
